import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { defaultProps, propTypes } from './types';

import fetchAPI from '../../../utils/fetchAPI';
import { getUser } from '../../../utils/sessionInfo';

const MazTuInfoBeesCardInfoV2 = () => {
  const [USER] = useState(getUser());
  const [points, setPoints] = useState(0);
  useEffect(() => {
    const service = `v1/MX/customers/points`;
    fetchAPI({
      service: service,
      protocol: 'GET',
      callbackThen: (respondGET) => {
        if (respondGET?.data) {
          const storedUserData = localStorage.getItem('@selectType');
          const decoded = JSON.parse(storedUserData);
          setPoints(decoded.type === 'mixto' ? Number(respondGET?.data?.mixed) : Number(respondGET?.data?.exclusive));
        } else {
          setPoints(0);
        }
      },
      callbackCatch: () => {
        setPoints(0);
      },
    });
  }, [USER.ID]);
  return (
    <div className={styles.container}>
      <span className={`${styles[`points__digits--${points.length}`]} ${styles.points}`}>{points}</span>
    </div>
  );
};

MazTuInfoBeesCardInfoV2.propTypes = propTypes;
MazTuInfoBeesCardInfoV2.defaultProps = defaultProps;

export default MazTuInfoBeesCardInfoV2;
